export type TimeStampsProps = 'createdAt' | 'updatedAt';
export type SoftDeleteProps = 'deletedAt';

export const MINIMUM_TEXT = 1;

export const TINY_TEXT = 50;
export const SHORT_TEXT = 255;
export const IMAGE_TEXT = 1000;
export const MEDIUM_TEXT = 2000;

export const TEN_THOUSANDTH_SCALE = 4;
export const THOUSANDTH_SCALE = 3;
export const HUNDREDTHS_SCALE = 2;
export const TENTH_SCALE = 1;
export const ZERO_SCALE = 0;
